var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#71778a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23 -612)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 26,
    height: 30,
    transform: "translate(23 612)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-899.486 -6136.484)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10,20A10,10,0,1,1,20,10,10.011,10.011,0,0,1,10,20Zm-.219-8.723h0A.881.881,0,0,0,10,11.3h5.217a.869.869,0,0,0,0-1.739H10.435V3.478a.869.869,0,0,0-1.739,0v6.956a.87.87,0,0,0,.869.869.859.859,0,0,0,.216-.027Z",
    transform: "translate(925.486 6753.483)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.d7e5d8fa9ef649f23bd88648fefcf262.svg";
export { ForwardRef as ReactComponent };